(() => {
  let sdk;
  function loadCaptcha() {
    if(window.hcaptcha?.render)return Promise.resolve(window.hcaptcha);
    if(sdk)return sdk;
    sdk=new Promise((resolve,reject)=>{
      const script=document.createElement('script');
      const timer=setTimeout(()=>{sdk=null;reject(new Error('Verification could not load. Please try again.'));},15000);
      window.urbanGiftingCaptchaLoaded=()=>{clearTimeout(timer);resolve(window.hcaptcha);};
      script.src='https://js.hcaptcha.com/1/api.js?render=explicit&onload=urbanGiftingCaptchaLoaded';script.async=true;script.defer=true;
      script.onerror=()=>{clearTimeout(timer);sdk=null;script.remove();reject(new Error('Verification could not load. Please try again.'));};
      document.head.append(script);
    });
    return sdk;
  }
  function create({url,accessKey,sitekey,protectionMode='staff-approval',getFields,getAttempt,campaignSlug,invitationToken,dialog,beforeChallenge,afterChallenge,fetcher=window.fetch.bind(window)}) {
    const base=new URL(url);
    if(base.protocol!=='https:'||base.username||base.password||base.search||base.hash)throw Error('The request service could not be verified.');
    let widget,api,inflight,resolveSolve,rejectSolve,timer;
    function body(attempt,captchaToken){return{campaignSlug,invitationToken,fields:getFields(),selectedJson:attempt.selectedJson,captureKey:attempt.key,...captchaToken?{captchaToken}:{}};}
    async function request(path,payload,signal) {
      const controller=new AbortController();
      const cancel=()=>controller.abort();signal?.addEventListener('abort',cancel,{once:true});if(signal?.aborted)cancel();
      let timeout;
      try{
        return await Promise.race([
          (async()=>{const response=await fetcher(new URL(path,base).href,{method:'POST',headers:{'Content-Type':'application/json',...(accessKey?{'X-Gifting-Staging-Key':accessKey}:{})},body:JSON.stringify(payload),credentials:'omit',cache:'no-store',signal:controller.signal});const data=await response.json();return{ok:response.ok,status:response.status,json:async()=>data};})(),
          new Promise((_,reject)=>{timeout=setTimeout(()=>{cancel();reject(new Error('The connection timed out. Your details are kept. Please try again.'));},45000);}),
        ]);
      }finally{clearTimeout(timeout);signal?.removeEventListener('abort',cancel);}
    }
    function settle(token,error) {
      if(!resolveSolve)return;
      const resolve=resolveSolve,reject=rejectSolve;resolveSolve=null;rejectSolve=null;clearTimeout(timer);
      if(error)reject(error);else resolve(token);
    }
    async function solveCaptcha() {
      // Staff approval is the business gate. This mode loads no provider SDK,
      // renders no challenge, and leaves the delivery dialog modal.
      if(protectionMode==='staff-approval')return undefined;
      if(protectionMode!=='hcaptcha')throw Error('The request service configuration is unavailable.');
      if(inflight)return inflight;
      inflight=(async()=>{
        api=await loadCaptcha();
        if(widget===undefined){
          const container=document.createElement('div');container.className='urban-gifting__verification';dialog.append(container);
          widget=api.render(container,{sitekey,size:'invisible',callback:token=>settle(token),'expired-callback':()=>settle(null,new Error('Verification expired. Please try again.')),'chalexpired-callback':()=>settle(null,new Error('Verification expired. Please try again.')),'error-callback':()=>settle(null,new Error('Verification could not be confirmed. Please try again.'))});
        }
        api.reset(widget);
        return await new Promise((resolve,reject)=>{
          resolveSolve=resolve;rejectSolve=reject;
          timer=setTimeout(()=>settle(null,new Error('Verification expired. Please try again.')),180000);
          beforeChallenge();
          try{api.execute(widget);}catch{settle(null,new Error('Verification could not start. Please try again.'));}
        });
      })().finally(()=>{try{if(api&&widget!==undefined)api.reset(widget);}finally{afterChallenge();inflight=null;}});
      return inflight;
    }
    return {
      solveCaptcha,
      async submit(attempt,captchaToken){
        const response=await request('/v1/requests',body(attempt,captchaToken));
        const result=await response.json();
        if(!response.ok)throw new Error(result.message||'Your request has not been confirmed yet. Please try again.');
        if(result.captureKey!==attempt.key||result.captured!==true)throw Error('Your request has not been confirmed yet. Please try again.');
      },
      async receiptFetch(receiptUrl,options){
        const attempt=getAttempt(),key=new URL(receiptUrl,location.origin).searchParams.get('q');
        if(!attempt||attempt.key!==key)throw Error('Your saved submission could not be verified.');
        return request('/v1/status',body(attempt),options?.signal);
      },
    };
  }
  window.UrbanGiftingDirect={create};
})();
